/**
 * Wait for a given amount of time.
 * @example
 * ```
 * console.log('waiting 1 second')
 * await wait(1000);
 * console.log('1 second later');
 * ```
 */
export function wait(ms: number) {
  return new Promise((resolve) => setTimeout(resolve, ms));
}
